/**
  clickable link that prompt user to download a file
  crosss platform for browser that doesn't support <a download={filename}/>  
 */
import * as React from "react";
import * as ReactDOM from "react-dom";
import {ProgressBarControl} from "./ProgressBarControl";
import logger from "../Utils/logger";
import {parseUserAgent, KnownBrowsers} from "../Utils/userAgent";
import browserCaps from "../Utils/browserCaps";
import {ProgressRingControl} from "./ProgressRingControl";
export interface DownloadLinkProps extends React.Props<DownloadLinkControl> {
    fileName: string;
    pendingDownload?: string;
    blobUrl?: string;
    downloadBlob?: () => JQueryPromise<Blob>;
    setBlobUrl?: (blobUrl: string) => void;
    asButton?: boolean;
}

export class DownloadLinkControl extends React.Component<DownloadLinkProps, any> {
    private pendingDownload = false;    
    constructor(props: DownloadLinkProps) {
        super(props);
    }

    private onDownload() {
        const fileName = this.props.fileName;
        if (this.props.downloadBlob) {
            this.pendingDownload = true;
            this.props.downloadBlob().then(blob => {
                // special work around for Edge browser according to
                // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/7260192/
                if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, this.props.fileName);
                } else {
                    if (browserCaps('a', 'download')) {
                        let $link = $('<a class="hidden"/>').text(fileName)
                        $link.appendTo($('body'));
                        let blobUrl = URL.createObjectURL(blob);
                        $link.attr('download', fileName).attr('href', blobUrl);
                        $link[0].click();
                        window.URL.revokeObjectURL(blobUrl);
                        $link.remove();
                    } else {
                        logger.debug('no download support, expect blobUrl property to be set');
                    }
                }
            }).always(() => {
                this.pendingDownload = false;
                this.forceUpdate();
            });
            this.forceUpdate();            
        } else {
            logger.debug('now downloadBlob found');
        }
    }

    private renderDownloadButton() : JSX.Element {
        const pending = this.pendingDownload || !!this.props.pendingDownload;
        const label = pending ? 'Downloading' : 'Download zip file';
        if (this.props.blobUrl) {
            return (
                <a className="light-buttton" href={this.props.blobUrl} download={this.props.fileName}>
                    {label}
                </a>
            );
        }
        return (
            <button className="light-button"
                disabled={pending}
                onClick={x => this.onDownload()}>
                {pending ? <ProgressRingControl className="downloading-zip-progress"/> : null}
                {label}
            </button>
        );
    }

    public render(): JSX.Element {
        const fileName = this.props.fileName;
        if (this.props.asButton) {
            return this.renderDownloadButton();
        }

        if (this.pendingDownload || this.props.pendingDownload) {
            return (
                <div className="pending-download">
                    <label>{this.props.pendingDownload || 'downloading'}</label>
                    <ProgressBarControl loading={true}/>
                </div>);
        }

        let link = this.props.blobUrl ?
            <a href={this.props.blobUrl} download={fileName}>{fileName}</a>
            : 
            <a href= '#' onClick= {
                    e => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.onDownload();
                    } }>{ fileName }
            </a>;
        return link;
    }
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/DownloadLinkControl.tsx